module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//empty_2.png?v=975e51d8";